import Templates from "./Templates/Templates";
import TemplatesDetail from "./Templates/TemplatesDetail";
import History from "./History/History";
import ModerationList from "./Moderation/ModerationList";
import AIReview from "./AIReview/AIReview";

export default {
  Templates,
  TemplatesDetail,
  History,
  ModerationList,
  AIReview,
};
